<script lang="ts" setup>
import ConditionForm from "@/components/form/ConditionForm.vue"
import { useHttpClient } from "@/vf"
import { ref } from "vue"

const http = useHttpClient()
const emit = defineEmits<{
    (e: "signed", form: FormData): void
}>()

async function save() {
    saving.value = true
    const formData = new FormData(document.getElementById("conditionForm") as HTMLFormElement)
    const pdfData = (
        await http.post<Blob>("/legal/form/pdf/?condition=General.Staff", formData, {
            responseType: "blob",
        })
    ).data

    //const form = new FormData()
    formData.append("document", pdfData)
    emit("signed", formData)
}

const isFormValid = ref(true)
const saving = ref(false)

// even though this isn't used, it's required to make the form work, because some values get calculated based on this
// object...
const data = ref({})
</script>

<template>
    <ConditionForm
        condition="General.Staff"
        formId="conditionForm"
        @validate="isFormValid = $event"
        v-model="data"
    ></ConditionForm>
    <div class="text-right">
        <button :disabled="!isFormValid || saving" class="btn btn-primary" @click="save()">
            <template v-if="saving">
                <i class="fas fa-spinner fa-spin"></i>
            </template>
            <template v-else>
                {{ $t("@tasks:tasks.staff.sign") }}
            </template>
        </button>
    </div>
</template>
